import React from 'react';
import Footer from '../component/Footer';

const MaxillofacialSurgery = () => {
    return (
        <>
            <div className="container">
                
                <div className="text-center my-5">
                    <h1>Maxillofacial Surgery</h1>
                </div>

               
                <div className="row">
                    <div className="col-md-12">
                        <p>
                            Maxillofacial surgery focuses on the diagnosis and treatment of conditions
                            affecting the face, mouth, and jaws. This includes procedures such as jaw surgery,
                            facial reconstruction, and the treatment of oral cancers.
                        </p>
                        <p>
                            Our team of experienced surgeons is equipped with advanced technology to perform complex
                            surgeries with precision and care. We are committed to restoring both the function and
                            aesthetics of your facial structures.
                        </p>
                        <p>
                            Whether you need corrective surgery for a misaligned jaw, facial trauma repair, or treatment
                            for oral pathology, our team provides comprehensive care tailored to your needs.
                        </p>
                    </div>
                </div>
            </div>

           
            <Footer />
        </>
    );
}

export default MaxillofacialSurgery;
